module.exports = __webpack_public_path__ + "55b28b500226e6177e0351ccd6e8f6a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/slideshow_01_mobile.jpg
// module id = 652
// module chunks = 0